import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable()
export class NbsextratorService {

  constructor(private http: HttpClient) { }

  listarEmpresas(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.URL_API}/nbs-extrator/empresas`, {
      headers: this.cabecalhos()
    });
  }

  consultarSincronizacao(idDealer: number, codDealer: string): Observable<any> {
    return this.http.get(`${environment.URL_API}/nbs-extrator/sincronizacao`, {
      headers: this.cabecalhos(),
      params: this.parametrosDealer(idDealer, codDealer)
    });
  }

  listarOperacoes(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.URL_API}/nbs-extrator/operacoes`, {
      headers: this.cabecalhos()
    });
  }

  incluirOperacao(codDealer: string, corpo: { codOperacao: number, descricao: string, ativo: boolean, horario: string, visualizarMonitor: boolean }): Observable<any> {
    return this.http.post(`${environment.URL_API}/nbs-extrator/operacoes`, corpo, {
      headers: this.cabecalhos(),
      params: new HttpParams().set('codDealer', codDealer || '')
    });
  }

  alterarOperacao(codDealer: string, codOperacao: number, corpo: { descricao: string, ativo: boolean, horario: string, hashLinha: string, visualizarMonitor: boolean }): Observable<any> {
    return this.http.put(`${environment.URL_API}/nbs-extrator/operacoes/${codOperacao}`, corpo, {
      headers: this.cabecalhos(),
      params: new HttpParams().set('codDealer', codDealer || '')
    });
  }

  listarCruzamentos(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.URL_API}/nbs-extrator/cruzamentos`, {
      headers: this.cabecalhos()
    });
  }

  incluirCruzamento(codDealer: string, corpo: { codEmpresa: number, codOperacao: number, ativo: boolean }): Observable<any> {
    return this.http.post(`${environment.URL_API}/nbs-extrator/cruzamentos`, corpo, {
      headers: this.cabecalhos(),
      params: new HttpParams().set('codDealer', codDealer || '')
    });
  }

  alterarCruzamento(codDealer: string, codCruzamento: number, corpo: { codEmpresa: number, codOperacao: number, ativo: boolean, hashLinha: string }): Observable<any> {
    return this.http.put(`${environment.URL_API}/nbs-extrator/cruzamentos/${codCruzamento}`, corpo, {
      headers: this.cabecalhos(),
      params: new HttpParams().set('codDealer', codDealer || '')
    });
  }

  excluirCruzamento(codDealer: string, codCruzamento: number, hashLinha: string): Observable<any> {
    return this.http.delete(`${environment.URL_API}/nbs-extrator/cruzamentos/${codCruzamento}`, {
      headers: this.cabecalhos(),
      params: new HttpParams().set('codDealer', codDealer || '').set('hashLinha', hashLinha || '')
    });
  }

  configurarCruzamento(codDealer: string, codCruzamento: number, corpo: {
    hashLinha: string,
    tipoIntegracao: string,
    usaDataInicio: boolean,
    dataInicio: string,
    urlHomologacao: string,
    urlProducao: string,
    idGrupoEmail: number,
    diasMonitor: number
  }): Observable<any> {
    return this.http.put(`${environment.URL_API}/nbs-extrator/cruzamentos/${codCruzamento}/configuracao`, corpo, {
      headers: this.cabecalhos(),
      params: new HttpParams().set('codDealer', codDealer || '')
    });
  }

  limparMonitor(codDealer: string, corpo: {
    codEmpresa: number,
    codOperacao: number,
    modo: string,
    dataInicial?: string,
    dataFinal?: string
  }): Observable<{ movimentos: number, detalhes: number }> {
    return this.http.post<{ movimentos: number, detalhes: number }>(`${environment.URL_API}/nbs-extrator/monitor/limpeza`, corpo, {
      headers: this.cabecalhos(),
      params: new HttpParams().set('codDealer', codDealer || '')
    });
  }

  listarClientes(filtro: {
    empresas?: { codDealer: string, codEmpresa: number }[],
    status?: string,
    tipoPessoa?: string,
    codigo?: string,
    nome?: string,
    tipoData?: string,
    dataInicial?: string,
    dataFinal?: string
  }): Observable<any[]> {
    let params = new HttpParams();
    params = this.aplicarEmpresas(params, filtro.empresas);
    if (filtro.status) {
      params = params.set('status', filtro.status);
    }
    if (filtro.tipoPessoa) {
      params = params.set('tipoPessoa', filtro.tipoPessoa);
    }
    if (filtro.codigo) {
      params = params.set('codigo', filtro.codigo);
    }
    if (filtro.nome) {
      params = params.set('nome', filtro.nome);
    }
    if (filtro.tipoData) {
      params = params.set('tipoData', filtro.tipoData);
    }
    if (filtro.dataInicial) {
      params = params.set('dataInicial', filtro.dataInicial);
    }
    if (filtro.dataFinal) {
      params = params.set('dataFinal', filtro.dataFinal);
    }
    return this.http.get<any[]>(`${environment.URL_API}/nbs-extrator/monitor/clientes`, {
      headers: this.cabecalhos(),
      params
    });
  }

  reenviarCliente(codDealer: string, escopo: string, codMovimento: string, codOperacao = 8): Observable<any> {
    let params = new HttpParams().set('codDealer', codDealer || '').set('escopo', escopo || '').set('codOperacao', String(codOperacao));
    if (codMovimento) {
      params = params.set('codMovimento', codMovimento);
    }
    return this.http.post(`${environment.URL_API}/nbs-extrator/monitor/clientes/reenvio`, null, {
      headers: this.cabecalhos(),
      params
    });
  }

  listarProdutivos(filtro: { empresas?: { codDealer: string, codEmpresa: number }[], status?: string, cpf?: string, nome?: string, tipoData?: string, dataInicial?: string, dataFinal?: string }): Observable<any[]> {
    let params = new HttpParams();
    params = this.aplicarEmpresas(params, filtro.empresas);
    if (filtro.status) {
      params = params.set('status', filtro.status);
    }
    if (filtro.cpf) {
      params = params.set('cpf', filtro.cpf);
    }
    if (filtro.nome) {
      params = params.set('nome', filtro.nome);
    }
    if (filtro.tipoData) {
      params = params.set('tipoData', filtro.tipoData);
    }
    if (filtro.dataInicial) {
      params = params.set('dataInicial', filtro.dataInicial);
    }
    if (filtro.dataFinal) {
      params = params.set('dataFinal', filtro.dataFinal);
    }
    return this.http.get<any[]>(`${environment.URL_API}/nbs-extrator/monitor/produtivos`, {
      headers: this.cabecalhos(),
      params
    });
  }

  listarDetalheProdutivo(codDealer: string, codMovimento: string): Observable<any[]> {
    return this.http.get<any[]>(`${environment.URL_API}/nbs-extrator/monitor/produtivos/detalhes`, {
      headers: this.cabecalhos(),
      params: new HttpParams().set('codDealer', codDealer || '').set('codMovimento', codMovimento || '')
    });
  }

  listarCompras(filtro: { empresas?: { codDealer: string, codEmpresa: number }[], status?: string, numero?: string, codControle?: string, tipoData?: string, dataInicial?: string, dataFinal?: string }): Observable<any[]> {
    let params = new HttpParams();
    params = this.aplicarEmpresas(params, filtro.empresas);
    if (filtro.status) {
      params = params.set('status', filtro.status);
    }
    if (filtro.numero) {
      params = params.set('numero', filtro.numero);
    }
    if (filtro.codControle) {
      params = params.set('codControle', filtro.codControle);
    }
    if (filtro.tipoData) {
      params = params.set('tipoData', filtro.tipoData);
    }
    if (filtro.dataInicial) {
      params = params.set('dataInicial', filtro.dataInicial);
    }
    if (filtro.dataFinal) {
      params = params.set('dataFinal', filtro.dataFinal);
    }
    return this.http.get<any[]>(`${environment.URL_API}/nbs-extrator/monitor/compras`, {
      headers: this.cabecalhos(),
      params
    });
  }

  listarDetalheCompra(codDealer: string, codMovimento: string): Observable<any[]> {
    return this.http.get<any[]>(`${environment.URL_API}/nbs-extrator/monitor/compras/detalhes`, {
      headers: this.cabecalhos(),
      params: new HttpParams().set('codDealer', codDealer || '').set('codMovimento', codMovimento || '')
    });
  }

  listarBalcao(filtro: { empresas?: { codDealer: string, codEmpresa: number }[], status?: string, numero?: string, cpf?: string, tipoData?: string, dataInicial?: string, dataFinal?: string }): Observable<any[]> {
    let params = new HttpParams();
    params = this.aplicarEmpresas(params, filtro.empresas);
    if (filtro.status) {
      params = params.set('status', filtro.status);
    }
    if (filtro.numero) {
      params = params.set('numero', filtro.numero);
    }
    if (filtro.cpf) {
      params = params.set('cpf', filtro.cpf);
    }
    if (filtro.tipoData) {
      params = params.set('tipoData', filtro.tipoData);
    }
    if (filtro.dataInicial) {
      params = params.set('dataInicial', filtro.dataInicial);
    }
    if (filtro.dataFinal) {
      params = params.set('dataFinal', filtro.dataFinal);
    }
    return this.http.get<any[]>(`${environment.URL_API}/nbs-extrator/monitor/balcao`, {
      headers: this.cabecalhos(),
      params
    });
  }

  listarDetalheBalcao(codDealer: string, codMovimento: string): Observable<any[]> {
    return this.http.get<any[]>(`${environment.URL_API}/nbs-extrator/monitor/balcao/detalhes`, {
      headers: this.cabecalhos(),
      params: new HttpParams().set('codDealer', codDealer || '').set('codMovimento', codMovimento || '')
    });
  }

  listarOs(filtro: { empresas?: { codDealer: string, codEmpresa: number }[], status?: string, numeroOs?: string, idNumeroOs?: string, tipoData?: string, dataInicial?: string, dataFinal?: string }): Observable<any[]> {
    let params = new HttpParams();
    params = this.aplicarEmpresas(params, filtro.empresas);
    if (filtro.status) {
      params = params.set('status', filtro.status);
    }
    if (filtro.numeroOs) {
      params = params.set('numeroOs', filtro.numeroOs);
    }
    if (filtro.idNumeroOs) {
      params = params.set('idNumeroOs', filtro.idNumeroOs);
    }
    if (filtro.tipoData) {
      params = params.set('tipoData', filtro.tipoData);
    }
    if (filtro.dataInicial) {
      params = params.set('dataInicial', filtro.dataInicial);
    }
    if (filtro.dataFinal) {
      params = params.set('dataFinal', filtro.dataFinal);
    }
    return this.http.get<any[]>(`${environment.URL_API}/nbs-extrator/monitor/os`, {
      headers: this.cabecalhos(),
      params
    });
  }

  listarDetalheOs(codDealer: string, codMovimento: string): Observable<any[]> {
    return this.http.get<any[]>(`${environment.URL_API}/nbs-extrator/monitor/os/detalhes`, {
      headers: this.cabecalhos(),
      params: new HttpParams().set('codDealer', codDealer || '').set('codMovimento', codMovimento || '')
    });
  }

  listarOperacao(filtro: { codOperacao: number, empresas?: { codDealer: string, codEmpresa: number }[], status?: string, registro?: string, descricao?: string, tipoData?: string, dataInicial?: string, dataFinal?: string }): Observable<any[]> {
    let params = new HttpParams().set('codOperacao', String(filtro.codOperacao));
    params = this.aplicarEmpresas(params, filtro.empresas);
    if (filtro.status) {
      params = params.set('status', filtro.status);
    }
    if (filtro.registro) {
      params = params.set('registro', filtro.registro);
    }
    if (filtro.descricao) {
      params = params.set('descricao', filtro.descricao);
    }
    if (filtro.tipoData) {
      params = params.set('tipoData', filtro.tipoData);
    }
    if (filtro.dataInicial) {
      params = params.set('dataInicial', filtro.dataInicial);
    }
    if (filtro.dataFinal) {
      params = params.set('dataFinal', filtro.dataFinal);
    }
    return this.http.get<any[]>(`${environment.URL_API}/nbs-extrator/monitor/operacao`, {
      headers: this.cabecalhos(),
      params
    });
  }

  listarDetalheOperacao(codOperacao: number, codDealer: string, codMovimento: string): Observable<any[]> {
    return this.http.get<any[]>(`${environment.URL_API}/nbs-extrator/monitor/operacao/detalhes`, {
      headers: this.cabecalhos(),
      params: new HttpParams()
        .set('codOperacao', String(codOperacao))
        .set('codDealer', codDealer || '')
        .set('codMovimento', codMovimento || '')
    });
  }

  listarDetalheCliente(codDealer: string, codMovimento: string): Observable<any[]> {
    return this.http.get<any[]>(`${environment.URL_API}/nbs-extrator/monitor/clientes/detalhes`, {
      headers: this.cabecalhos(),
      params: new HttpParams().set('codDealer', codDealer || '').set('codMovimento', codMovimento || '')
    });
  }

  listarGruposEmail(codDealer: string): Observable<any[]> {
    return this.http.get<any[]>(`${environment.URL_API}/nbs-extrator/grupos-email`, {
      headers: this.cabecalhos(),
      params: new HttpParams().set('codDealer', codDealer || '')
    });
  }

  excluirOperacao(codDealer: string, codOperacao: number, hashLinha: string): Observable<any> {
    return this.http.delete(`${environment.URL_API}/nbs-extrator/operacoes/${codOperacao}`, {
      headers: this.cabecalhos(),
      params: new HttpParams().set('codDealer', codDealer || '').set('hashLinha', hashLinha || '')
    });
  }

  alterarEmpresa(idDealer: number, codDealer: string, codEmpresa: number, corpo: { ambiente: string, ativo: boolean, hashLinha: string }): Observable<any> {
    return this.http.put(`${environment.URL_API}/nbs-extrator/empresas/${codEmpresa}`, corpo, {
      headers: this.cabecalhos(),
      params: this.parametrosDealer(idDealer, codDealer)
    });
  }

  private parametrosDealer(idDealer: number, codDealer: string): HttpParams {
    if (idDealer) {
      return new HttpParams().set('idDealer', String(idDealer));
    }
    return new HttpParams().set('codDealer', codDealer || '');
  }

  private aplicarEmpresas(params: HttpParams, empresas?: { codDealer: string, codEmpresa: number }[]): HttpParams {
    (empresas || []).forEach(empresa => {
      if (empresa && empresa.codDealer && empresa.codEmpresa != null) {
        params = params.append('empresas', empresa.codDealer + ':' + empresa.codEmpresa);
      }
    });
    return params;
  }

  private cabecalhos(): HttpHeaders {
    const usuario = JSON.parse(sessionStorage.getItem('currentUser'));
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': usuario ? usuario.token : ''
    });
  }
}
